import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

const AccessControl = ({ allowedRoles }) => {
  const { user } = useSelector((state) => state.auth);
  const hasCHDelegatedAccess =
    user?.is_ch_functioning_specialist &&
    user?.role !== "CLINICAL_HEAD" &&
    allowedRoles.includes("CLINICAL_HEAD");

  return allowedRoles.includes(user?.role) || hasCHDelegatedAccess ? (
    <Outlet />
  ) : (
    <Navigate to="/unauthorized" />
  );
};

export default AccessControl;
